












































import { Component, Prop, Mixins, Emit } from 'vue-property-decorator';
import { AuthEvent } from '../../../store';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { AuthStoreHelper } from '../../core/mixins';

@Component
export default class UserLogged extends Mixins(AuthStoreHelper) {
    @Prop() logout: Function;
    @Prop() setting: Function;
    @Prop() redirect: Function;
    @Prop() startTour: Function;
    @Prop() redirectToAdmin: Function;
    @Prop({ default: 'User' }) user: string;

    unsubscribe: () => void;
    showRedirectToAdmin: boolean = false;

    get getAdminPermission() {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.ADMIN, PRIVILEGE_TYPES.EDIT_AND_DELETE);
    }

    showRedirectToAdm() {
        if (this.getAdminPermission) this.showRedirectToAdmin = true;
    }

    created() {
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
            this.checkPermissions();
        });
    }

    checkPermissions() {
        this.showRedirectToAdm();
    }

    destroyed() {
        this.unsubscribe();
    }

    @Emit()
    showUserPreferencesModal(){}
}
